import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = () => ({
  step: 0,
  address: null,
  phone: null,
  skills: [],
  memberEquipment: [],
  profile: null,
  possibleStatuses: [],
  productTypes: [],
  productSubtypes: [],
  documents: [],
  identificationTypes: [],
  equipments: [],
  languages: [],
  loading: false,
});

export default {
  mutations,
  actions,
  getters,
  state,
};
